module.exports = __webpack_public_path__ + "built-card-bottom-right.1FMwCFg8.png";